<div [@slideSwitch]="selectedRecommendation" class="drawer-content-container">
    <span [class.hidden]="selectedRecommendation !== RecommendationType.Task" class="d-flex flex-column h-100">
        <div class="card-header d-flex align-items-center justify-content-center position-relative p-1 border-0 mb-3">
            <div class="text-center w-100">
                <h5 class="heading mb-0 fs-6">Tasks</h5>
            </div>
            <button type="button" class="btn btn-sm position-absolute end-0 d-block d-sm-none me-2"
                (click)="onCloseClick()"> <i class="bi bi-x-circle "></i></button>
        </div>
        <cva-consultation-tasks class="h-container" [practitionerId]="practitionerId"
            [patientId]="patientId"></cva-consultation-tasks>
    </span>

    <span [class.hidden]="selectedRecommendation !== RecommendationType.Medication" class="d-flex flex-column h-100">
        <div class="card-header d-flex align-items-center justify-content-center position-relative p-1 border-0 mb-3">
            <div class="text-center w-100">
                <h5 class="heading mb-0 fs-6">Medications</h5>
            </div>
            <button type="button" class="btn btn-sm position-absolute end-0 d-block d-sm-none me-2"
                (click)="onCloseClick()"> <i class="bi bi-x-circle "></i></button>
        </div>
        <cva-consultation-medications class="h-container" [practitionerId]="practitionerId"
            [patientId]="patientId"></cva-consultation-medications>
    </span>

    <span [class.hidden]="selectedRecommendation !== RecommendationType.Classification"
        class="d-flex flex-column h-100">
        <div class="card-header d-flex align-items-center justify-content-center position-relative p-1 border-0 mb-3">
            <div class="text-center w-100">
                <h5 class="heading mb-0 fs-6">Classifications</h5>
            </div>
            <button type="button" class="btn btn-sm position-absolute end-0 d-block d-sm-none me-2"
                (click)="onCloseClick()"> <i class="bi bi-x-circle "></i></button>
        </div>
        <cva-consultation-classification class="h-container" [practitionerId]="practitionerId" [patientId]="patientId"
            [notesApproved]="notesApproved"></cva-consultation-classification>
    </span>

    <span [class.hidden]="selectedRecommendation !== RecommendationType.ACC_ELIGIBILITY"
        class="d-flex flex-column h-100">
        <div class="card-header d-flex align-items-center justify-content-center position-relative p-1 border-0 mb-3">
            <div class="text-center w-100">
                <h5 class="heading mb-0 fs-6">ACC Eligibility <span class="beta-chip">BETA</span></h5>
            </div>
            <button type="button" class="btn btn-sm position-absolute end-0 d-block d-sm-none me-2"
                (click)="onCloseClick()"> <i class="bi bi-x-circle "></i></button>
        </div>
        <cva-consultation-acc-eligibility class="h-container" [patientId]="patientId" [practitionerId]="practitionerId"
            [patientAge]="patientAge"></cva-consultation-acc-eligibility>
    </span>
</div>